import { Form,Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import React,{ useState , useEffect} from 'react';
import FormContainer from '../components/FormContainer';
import { FormComboBox } from '../validation/Form-Components';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import SubHeader from '../components/SubHeader';
import headerImg from '../images/Stepper3.png'; 
import branches from '../data/branch.json';
import acctDtlsData from '../data/acctdetailsdata.json';
import { reqDDLValidator } from '../validation/Validators';
import img from '../images/Building.png';
import { useHistory } from 'react-router-dom';
import CusToast from '../components/CusToast';
import service from '../services/AcctDtlsApiService';
import helper from '../factory/Helper';
import storage from '../factory/StorageFactory';
import { Input } from '@progress/kendo-react-inputs';
import CusTwoBtnDialog from '../components/CusTwoBtnDialog';
import CusOneBtnDialog from '../components/CusOneBtnDialog';
import LoadingText from '../components/LoadingText';
import { Button } from "@progress/kendo-react-buttons";
 
const AccountDetails = (props) => {

    let count = 0;
    let timer, acctListTimer, uiLoadingTimer;
    let casaAccts = null;

    const history = useHistory();
    
    const [isLoading, setIsLoading] = useState(true); //default true;
    const [isSaving,setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response, setResponse] = useState();
    const [branchList, setBranchList] = useState(branches);
    const [prefAccounts, setPrefAccounts] = useState([]); //added dummy data, actual data should be from api

    const [showActiveAcctDialog, setShowActiveAcctDialog] = useState(false);
    const [showNoAcctDialog, setShowNoAcctDialog] = useState(false);
    const [isAcctRetrieving, setIsAcctRetrieving] = useState(false);
    const [acctRetrievingMsg, setAcctRetrievingMsg] = useState(acctDtlsData.label.firstLoading);
    const [noCasaAcctMsg, setNoCasaAcctMsg] = useState(acctDtlsData.label.NoActiveAccountDialog);
    

    const [acctDetails, setAcctDetails] = useState({
        PrefBranch: '',
        PrefAcct: '' 
    })

 //  const [showExitPrompt, setShowExitPrompt] = useExitPrompt(false);

    useEffect(() => {
        console.log('@AccountDetails useEffect');

      // setShowExitPrompt(!showExitPrompt);

        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }
        
        window.scrollTo(0,0);
        getData();

        return () => {
            
            clearTimeout(timer);
            clearTimeout(acctListTimer);
            clearTimeout(uiLoadingTimer);
          //  setShowExitPrompt(false);
        }
    }, []);
    
 
    //bank branch selection
    const handlePrefBranch = (e) => {
        if(e.value === null){
            return;
        }
    }

    const handlePrefAccount = (e) => {
        if(e.value === null){
            return;
        }
    }

    const handleSubmit = (dataItem) => {
        
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
   
            saveAccountDetails(formatJsonParams(data));
        }
    }

    const handleBack = (e) => {
        e.preventDefault();
        history.push(config.route.NSPersonDetails);
    }

    const getData = () => {
        
        service.getBranches().then( res => {
            if(res.data.didError === false) {
                const excludedBranches = config.AcctList.ExcludedBranches || [];
                const filteredBranches = res.data.model.filter(b => !excludedBranches.includes(b.branchDescription));
                setBranchList(filteredBranches);
                getAcctList();
            }
            else {
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }


    const getAcctList = () => {

        let refNo = storage.getRefNo();
       
        service.getAcctList(refNo).then( res => {
            let resData = res.data;
            if(resData.isSucess) {
                getAccountDetails(resData.model.fields.request.Accountlist);
            }
            else {
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const getAccountDetails = (acctListResData) => {
        let acctList = [];
        service.getAcctDtls().then( res => {
            if(res.data.isSucess) {
                if(res.data.model.disbursement_Branch_Code === null) { //first time
                    setIsLoading(false);
                    acctList = getAcctListArray(acctListResData);
                    // new enhancement
                    if(acctListResData === null || acctList.length === 0) {
                        setShowActiveAcctDialog(true);
                    }
                    else {
                        setPrefAccounts(acctList)
                        setResponse(res.data.model);
                        bindFormData(res.data.model);
                    }

                    //Existing workflow
                    /*
                    if(count < config.AcctList.NumOfApiCallTime && acctListResData === null) {
                        setAcctListTimeout();
                    }
                    else {
                        setIsLoading(false);
                        setPrefAccounts(acctList)
                        setResponse(res.data.model);
                        bindFormData(res.data.model);
                    }
                    */
                }
                else { //not first time
                    setIsLoading(false);
                    acctList = getAcctListArray(acctListResData);
                    setPrefAccounts(acctList)
                    setResponse(res.data.model);
                    bindFormData(res.data.model);
                }
            }
            else {
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
     
        })
        .catch(err => {
            console.log('err: ',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const getAcctListArray = (data) => {
        let temp = [] ;
        if(data !== null) {
            let jData = JSON.parse(data);
   
            if(!Array.isArray(jData)) {
            
                if(jData.accountNumber){
                    temp.push({value:jData.accountNumber,label:jData.accountNumber});
                }
            }
            else {
                for(let i in jData) {
                    if(jData[i].accountNumber){
                        temp.push({value:jData[i].accountNumber,label:jData[i].accountNumber});
                    }
                }
            }
        }
     
        return temp;
    }

    const bindFormData = (data) => {
 
        try {
            setAcctDetails({
                PrefBranch:data.disbursement_Branch_Code === null? '': helper.getBranchObjInArray(data.disbursement_Branch_Code,branchList),
                PrefAcct: data.disbursement_Branch_Account_No === null? '': helper.getObjInArray(data.disbursement_Branch_Account_No,prefAccounts)
            })
        }catch(e) {

        }
    }

    const saveAccountDetails = (params) => {
        setIsSaving(true);
        service.post(params).then(res => {    
            setIsSaving(false);
            if(res.data.isSucess) {
                goNext();
            }  
            else {
                showErrMsg(config.error.SaveApiFailed);
            } 
        }).catch(err => {
            console.log('err: ',err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        })
    }

    let formatJsonParams = function(data) {
 
        let params = {
            stateId:storage.getStateId(),
            referenceNo: storage.getRefNo(),
            disbursement_Branch_Code: data.PrefBranch.branchCode,
            disbursement_Branch_Desc: data.PrefBranch.branchDescription,
            disbursement_Branch_Account_No: getPrefAcctValue(data) 
        }

        return params;
    }

    const getPrefAcctValue = (data) => {
        let prefAcctValue = '';
        
        if(prefAccounts.length === 1) {
            prefAcctValue = prefAccounts[0].label;
        }
        else if(prefAccounts.length > 1){
            prefAcctValue = data.PrefAcct.label?data.PrefAcct.label:''
        }

        return prefAcctValue;
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const setAcctListTimeout = () => {
        acctListTimer = setTimeout(() => {
         
            count = count +1;
            getAcctList();
        }, config.AcctList.ApiCallTimeout)
    }

    const setUILoadingTimeout = () => {
        uiLoadingTimer = setTimeout(() => {
            count = count +1;
            //continue UI loading
            // console.log('setUILoadingTimeout ',count);
            if(count < config.AcctList.NumOfApiCallTime) {
                setAcctRetrievingMsg(acctDtlsData.label.secLoading);
                setUILoadingTimeout();
            }
            else {
               stopAcctRetrieving();
                if(casaAccts === null) {
                    showNoResultFromWAADialog();
                }
            }
        }, config.AcctList.UILoadingTimeout)
    }

    const setAcctListApiCallTimeout = () => {
   
        acctListTimer = setTimeout(() => {
            // console.log('@setAcctListApiCallTimeout');
            checkAcctNumResultFromWAA();
        }, config.AcctList.ApiCallTimeout)
    }
    
    const checkAcctNumResultFromWAA = () => {
        let acctListArray = [];
        let refNo = storage.getRefNo();
        service.getAcctList(refNo).then( res => {
            let resData = res.data;
            if(resData.isSucess) {
                // console.log('@getAcctList api call success');
                casaAccts = resData.model.fields.request.Accountlist;
                if(resData.model.fields.request.Accountlist === null) {
                    //no result from WAA
                 
                    setAcctListApiCallTimeout();
                }
                else { // have result from WAA
                    stopAcctRetrieving();
                    acctListArray = getAcctListArray(resData.model.fields.request.Accountlist);
                    setPrefAccounts(acctListArray);

                    service.getAcctDtls().then( res => {
            
                        if(res.data.isSucess) {
                            setResponse(res.data.model);
                            bindFormData(res.data.model);

                            if(acctListArray.length === 0) { // no casa acct 
                                //show pop up
                                showUserHasNoCasaAcctDialog();
                            }
                        }
                        else {
                            showErrMsg(config.error.GetApiFailed);
                        }
                    })
                    .catch(err => {
                        console.log('err: ',err);
            
                        showErrMsg(config.error.GetApiFailed);
                    })
                }
            }
            else {
                stopAcctRetrieving();
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            stopAcctRetrieving();
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.DeclarationsDetails);
        }
    }

    const handleYesBtnClick = (e) => {
        e.preventDefault();
        setShowActiveAcctDialog(false);
        startAcctRetrieving()
    }

    const handleNoBtnClick = (e) => {
        e.preventDefault();
        setShowActiveAcctDialog(false);
        setShowNoAcctDialog(true);
    }
    
    const handleOkBtnClick = (e) => {
        e.preventDefault();
        setShowNoAcctDialog(false);
    }

    const startAcctRetrieving = () => {
        setIsAcctRetrieving(true);
        setAcctRetrievingMsg(acctDtlsData.label.firstLoading);
        setUILoadingTimeout();
        setAcctListApiCallTimeout();
    }

    const stopAcctRetrieving = () => {
        setIsAcctRetrieving(false);
        setAcctRetrievingMsg(acctDtlsData.label.firstLoading);
        clearTimeout(acctListTimer);
        clearTimeout(uiLoadingTimer);
    }

    const showNoResultFromWAADialog = () => {
        setShowNoAcctDialog(true);
        setNoCasaAcctMsg(acctDtlsData.label.NoResultFromWAADialog);
    }

    const showUserHasNoCasaAcctDialog = () => {
        setShowNoAcctDialog(true);
        setNoCasaAcctMsg(acctDtlsData.label.UserHasNoCasaAcctDialog);
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader title={config.Branding.title} img={headerImg}/> <br/>
            <Form onSubmitClick={handleSubmit}
                initialValues={acctDetails}
                key={JSON.stringify(acctDetails)}
                render={(formRenderProps)=>(
                    <FormElement>
                      
                        <FormContainer>
                            <fieldset>
                                <div style={{textAlign:'center',padding:'20px'}}>
                                    <img className="imgScc" src={img} alt="imgScc"></img>
                                </div>
                                <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible" >
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{acctDtlsData.label.PrefBranch}</div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 example-col" >
                                            <div className="box">
                                                <Field id={'PrefBranch'} 
                                                    name={'PrefBranch'}
                                                    component={FormComboBox}
                                                    textField={'branchDescription'}
                                                    data={branchList}
                                                    placeholder={'Please select'}
                                                    validator={reqDDLValidator}
                                                    onChange={handlePrefBranch} />
                                            </div>
                                        </div>
                                    </div>  

                                    {prefAccounts.length !==0 &&
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible" >
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{acctDtlsData.label.PrefAcct}</div>
                                            <div className="box">
                                                <div style={{fontSize:'12px',color:'grey'}}>{acctDtlsData.label.PrefAcctSub}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">
                                               {/* <Label style={{ fontWeight: "500", wordBreak: "break-word"}} className="box" editorId={'lblPrefAcct'}>{prefAccounts[0].label}</Label> */}
                                                {prefAccounts.length === 1?
                                                    <Input id={'PrefAcct'} value={prefAccounts[0].label}
                                                        disabled={true} />
                                                    :
                                                <Field id={'PrefAcct'} 
                                                    name={'PrefAcct'}
                                                    component={FormComboBox}
                                                    textField={'label'}
                                                    data={prefAccounts}
                                                    placeholder={'Please select'}
                                                    validator={reqDDLValidator}
                                                    onChange={handlePrefAccount} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    </FieldWrapper>}
                                </FieldWrapper>
                                <FieldWrapper></FieldWrapper>
                            </fieldset>
                        </FormContainer>

                        <FormContainer>
                            <div style={{paddingTop:'20px',paddingBottom:'20px'}}>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <Button type={'submit'} className="k-button btn btnMargin btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</Button>
                                        <Button type={'button'} style={{border:'1px solid #343a40'}} className="k-button btn btnMargin btn-back" onClick={handleBack}>{config.btnName.Back}</Button>
                                    </div>
                                </div>                            
                            </div>
                        </FormContainer>  
                    
                        <FieldWrapper></FieldWrapper>
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                        <CusTwoBtnDialog show={showActiveAcctDialog} setShow={setShowActiveAcctDialog} label={acctDtlsData.label.ActiveAccountDialog}
                            style={{ textAlign: "center", whiteSpace: "pre-line", fontWeight:'500'}}
                            leftBtnName={'Yes'} leftBtnClick={handleYesBtnClick}
                            rightBtnName={'No'} rightBtnClick={handleNoBtnClick} />
                        <CusOneBtnDialog show={showNoAcctDialog} setShow={setShowNoAcctDialog} 
                            label={noCasaAcctMsg}
                            btnName={'Ok'} btnClick={handleOkBtnClick} />
                        <LoadingText show={isAcctRetrieving} setShow={setIsAcctRetrieving} label={acctRetrievingMsg} />
                    </FormElement>
                )}>
            </Form>
            {isSaving && <Loading />}
        </div>
    )
}

export default AccountDetails;